import React from 'react';
import { Search } from 'lucide-react';
import './DashToolbar.css';

export default function DashToolbar({
  search,
  onSearch,
  searchPlaceholder = 'Rechercher…',
  filters = [],
  activeFilter,
  onFilter,
  right,
}) {
  return (
    <div className="dash-toolbar">
      <label className="dash-search">
        <Search size={16} />
        <input
          value={search}
          onChange={(e) => onSearch?.(e.target.value)}
          placeholder={searchPlaceholder}
        />
      </label>
      {filters.length > 0 && (
        <div className="dash-chips" role="tablist">
          {filters.map((f) => (
            <button
              key={f.id}
              type="button"
              role="tab"
              aria-selected={activeFilter === f.id}
              className={`dash-chip${activeFilter === f.id ? ' is-active' : ''}`}
              onClick={() => onFilter?.(f.id)}
            >
              {f.label}
              {typeof f.count === 'number' ? <span>{f.count}</span> : null}
            </button>
          ))}
        </div>
      )}
      {right ? <div className="dash-toolbar-right">{right}</div> : null}
    </div>
  );
}
